<template>
  <div class="account_recycle">
    <breadcrumb :link-list="breadcrumbList"></breadcrumb>
    <div class="header">
      <div class="headTitle">
        <img class="headIcon" src="@/assets/image/AccountDeal/gameSelectHead/accRecycleIcon.png">
        <div class="headText">账号回收</div>
        <div class="headTip">选择游戏后跳转号商列表</div>
      </div>
      <router-link :to="{name:'Home'}" class="headBack" v-if="step === 1" >返回首页</router-link>
      <div class="headBack" v-else @click="backBtn">返回</div>
    </div>
    <!--  账号回收 gameList -->
    <div class="recycle" v-if="step===1">
      <div class="introduce">
        <img class="introduceHead" src="@/assets/image/AccountDeal/accountRecycle/accRecycleIntr1.png">
        <div class="introduceBody">
          <div class="IB_card">
            <div class="card_title">
              <span></span>
              注意
            </div>
            <div class="card_text">合作号商均在平台缴纳高额保证金，谈好交易均通过平台交易。如号商有任何谩骂等情况发生均可带记录联系平台投诉建议进行投诉。平台一定严肃处理。</div>
            <div class="card_tip">注：平台只是提供一个方便出号的渠道，并非平台官方回收。</div>
          </div>
          <router-link tag="img" :src="require('@/assets/image/AccountDeal/accountRecycle/accRecycleIntr2.png')"
                       :to="{name:'TradeTip',query:{id:'112',parent_id:'83'}}"></router-link>
        </div>
      </div>
      <gameList :gameClick="gameClick" accRecycle :gameId="game_id"></gameList>
    </div>
    <!--  号商列表 merchantList -->
    <div class="merchantList" v-else-if="step===2">
      <div class="head">
        <img :src="selectGame.game_image" alt="">
        {{ selectGame.game_name }}&ensp;-&ensp;号商列表
      </div>
      <div class="list">
        <div class="merchant" v-for="(item,index) in merchantList" :key="index" @click="merchantClick(item)">
          <div class="name">号商：&ensp;{{ item.name }}</div>
          <div class="info">
            <div class="game">
              <div class="label">负责游戏：</div>
              <div class="gameName">
                {{ item.game_name }}
              </div>
            </div>
            <div class="other">
              <div class="safeguard">
                <img class="headIcon" src="@/assets/image/AccountDeal/accountRecycle/safeIcon.png">
                已缴纳保证金
              </div>
              <div class="infoBtn">
                号商详情 <i class="el-icon-caret-right"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  号商详情 merchantInfo -->
    <div class="merchantInfo" v-else-if="step===3">
      <div class="head">
        <div class="title">
          <img class="headIcon" src="@/assets/image/AccountDeal/accountRecycle/subtract.png">
          号商详情
        </div>
        <div class="merchant">
          <div class="name">号商：&ensp;{{ merchantInfo.name }}</div>
          <div class="info">
            <div class="game">
              <div>负责游戏：{{ merchantInfo.game_name }}</div>
              <div><img class="headIcon" src="@/assets/image/AccountDeal/accountRecycle/safeIcon.png">已缴纳保证金</div>
            </div>
           <a v-if="merchantInfo.link || merchantInfo.group_code" class="btn" href="javascript: void();" @click="goChat">联系号商</a>
          </div>
        </div>
      </div>
      <div  class="ql-container ql-snow">
        <p id="merchantInfo" class="ql-editor" v-html="merchantInfo.cdata"></p>
      </div>
    </div>
  </div>
</template>
<script>

import {apiRecyclingList,apiRecyclingInfo} from "@/request/API";
import breadcrumb from "@/components/breadcrumb";
import gameList from "@/components/gameList/index"

export default {
  name: '',
  props: {},
  components: {
    breadcrumb,
    gameList
  },
  data() {
    return {
      // 站内信详情联系号商，游戏id
      game_id: this.$route.query.game_id || '',
      // gameList 、 merchantList 、 merchantInfo
      step: 1,
      // 面包屑
      breadcrumbList: [
        {name: '账号交易'},
        {link: 'AccountRecycle', name: '账号回收'}
      ],
      // 选择的游戏
      selectGame: '',
      //号商列表
      merchantList:[],
      //号商详情
      merchantInfo:{}
    }
  },
  methods: {
    /**
     * @description: 跳转回收客服
     * @return {*}
     */
    goChat() {
      if (!this.$store.state.loginStatus) {
        this.$router.push({
          path: "/login",
          query:{
            Rurl: this.$route.fullPath
          }
        })
        return
      }
      const {link, group_code} = this.merchantInfo
      const params = {
        game_id: this.game_id || this.selectGame.game_id,
        id: link,
      }
      if(link) {
        params.serviceId = link
      } else {
        params.gameAlias = group_code
      }
      this.$openIM(params)
    },
    /**
     * 点击游戏事件
     * @param game
     */
    gameClick(game, next, sLetter,is_search_click,original_key_word) {
      this.$sensorsTrack.RecycleGameSelect(game.game_id,game.game_name,is_search_click,original_key_word)
      this.selectGame = game
      document.body.scrollTop = document.documentElement.scrollTop = 157
      this.step++
      this.getRecyclingList(game.game_id)
    },
    /**
     * 点击号商事件
     * @param merchant
     */
    merchantClick(merchant) {
      this.$sensorsTrack.VendorsSelect(this.selectGame.game_id,this.selectGame.game_name,merchant.id,merchant.name)
      this.merchantInfo = merchant
      this.step++
    },
    /**
     * 返回按钮
     */
    backBtn() {
      // 如果站内信详情跳转则返回站内信详情，否则step--
      if(this.game_id){
        this.$router.back()
      }else{
        this.step--
      }
    },
    /**
     * 获取号商列表
     * @param game_id
     */
    getRecyclingList(game_id){
      apiRecyclingList({
        game_id:game_id
      }).then(res=>{
        this.merchantList = res.data.sort((a,b)=> b.sort-a.sort)
      })
    },
  },
  mounted() {},
  watch: {
    step(val) {
      switch (val) {
        case 1:
          this.breadcrumbList = [
            {name: '账号交易'},
            {link: 'AccountRecycle', name: '账号回收'}
          ]
          break;
        case 2:
          this.breadcrumbList = [
            {name: '账号回收'},
            {name: '号商列表'},
          ]
          break;
        case 3:
          this.breadcrumbList = [
            {name: '账号回收'},
            {name: '号商列表'},
            {name: '号商详情'}
          ]
          break;
      }
    }
  },
  computed: {},
  beforeRouteEnter(to,from,next){
    next((vm) => {
      vm.$sensorsTrack.AccRecycleView(from.name)
    })
  }
}
</script>

<style  scoped>
.ql-container{
  border: none !important;
}
#merchantInfo >>> img{
  height: 100% !important;
  object-fit: cover !important;
}
</style>

<style lang='less' scoped>
.account_recycle {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 1200px;
  margin: 0 auto 32px;

  .header {
    width: 1200px;
    height: 100px;
    background: var(--bg-dark, #1A1D24);
    border-radius: 4px 4px 0 0;
    padding: 0 44px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    box-sizing: border-box;

    .headTitle {
      display: flex;
      flex-direction: row;
      align-items: center;

      .headIcon {
        width: 42px;
        height: 42px;
        object-fit: contain;
      }

      .headText {
        font-size: 24px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        text-align: CENTER;
        color: #FFFFFF;
        margin: 0 24px 0 10px;
      }

      .headTip {
        height: 28px;
        line-height: 28px;
        padding: 0 12px;
        border-radius: 4px;
        background: rgba(255, 255, 255, 0.14);
        border: 1px solid rgba(255, 255, 255, 0.24);
        font-size: 14px;
        font-family: PingFang SC, PingFang SC-Regular;
        font-weight: 400;
        color: rgba(255, 255, 255, 0.9);
      }

    }

    .headBack {
      height: 36px;
      line-height: 34px;
      padding: 0 16px;
      border: 1px solid rgba(255, 255, 255, 0.55);
      border-radius: 4px;
      background: rgba(255, 255, 255, 0.12);
      font-size: 15px;
      font-family: PingFang SC, PingFang SC-Semibold;
      font-weight: 500;
      color: #FFFFFF;
      cursor: pointer;
      box-sizing: border-box;
      transition: color 0.2s ease, background 0.2s ease, border-color 0.2s ease;

      &:hover {
        background: rgba(255, 255, 255, 0.2);
        border-color: rgba(255, 255, 255, 0.8);
      }
    }
  }

  .recycle {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 1200px;

    .introduce {
      margin: 0px 0px 18px;

      .introduceHead {
        margin: 18px 0 4px;
      }

      .introduceBody {
        display: flex;
        flex-direction: row;
        justify-content: space-evenly;

        .IB_card {
          margin: 3px 0 0;
          width: 640px;
          height: 144px;
          padding: 23px 34px 23px 43px;
          background: #ffffff;
          border-radius: 4px;
          box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.10);
          display: flex;
          flex-direction: column;
          justify-content: space-around;

          .card_title {
            font-size: 20px;
            font-family: PingFang SC, PingFang SC-Semibold;
            font-weight: 600;
            color: var(--warning, #F59E0B);
            line-height: 20px;

            span {
              display: inline-block;
              width: 4px;
              height: 14px;
              background: var(--warning, #F59E0B);
              margin: 0 14px 0 0;
            }
          }

          .card_text {
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Regular;
            font-weight: 400;
            color: var(--text-secondary, #5A5F6B);
            line-height: 25px;
          }

          .card_tip {
            font-size: 16px;
            font-family: PingFang SC, PingFang SC-Medium;
            font-weight: 500;
            color: var(--primary, #FF7A1A);
            line-height: 16px;
          }
        }

        img {
          cursor: pointer;
        }
      }
    }
  }

  .merchantList {
    width: calc(1200px - 50px);
    background: var(--bg-card, #FFFFFF);
    padding: 0 25px 100px;

    .head {
      display: flex;
      flex-direction: row;
      align-items: center;
      padding: 40px 18px;
      font-size: 24px;
      font-family: PingFang SC, PingFang SC-Regular;
      font-weight: 400;
      color: var(--text-main, #111827);
      border-bottom: 2px solid var(--border-soft, #E8E4DE);

      img {
        width: 80px;
        height: 80px;
        border-radius: 4px;
        margin: 0 25px 0 0;
        object-fit: cover;
        box-shadow: 0 6px 14px rgba(15, 23, 42, 0.08);
      }
    }

    .list {
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      padding: 0 30px;

      .merchant {
        width: 530px;
        background: var(--bg-section, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        margin: 20px 5px 0;
        cursor: pointer;
        overflow: hidden;
        box-sizing: border-box;
        transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;

        &:hover {
          border-color: rgba(26, 29, 36, 0.22);
          box-shadow: 0 10px 22px rgba(26, 29, 36, 0.12);
          transform: translateY(-2px);
        }

        .name {
          border-radius: 4px 4px 0 0;
          min-height: 58px;
          line-height: 58px;
          background: var(--bg-dark, #1A1D24);
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          color: #FFFFFF;
          padding: 0 0 0 21px;
        }

        .info {
          padding: 0 20px;

          .game {
            padding: 13px 0;
            border-bottom: 1px solid var(--border-soft, #E8E4DE);
            display: flex;
            flex-direction: row;

            .label {
              height: 52px;
              flex-shrink: 0;
            }

            .gameName {
              width: 355px;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              overflow: hidden;
              text-align: justify;
              text-justify: newspaper;
              word-break: break-all;
            }

            div {
              font-size: 16px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              text-align: LEFT;
              color: var(--text-secondary, #5A5F6B);
              line-height: 25px;
            }
          }

          .other {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
            padding: 11px 0 12px;

            .safeguard {
              display: flex;
              align-items: center;
              font-size: 16px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-secondary, #5A5F6B);

              img {
                margin: 0 8px 0 0;
              }
            }

            .infoBtn {
              font-size: 16px;
              font-family: PingFang SC, PingFang SC-Medium;
              font-weight: 500;
              color: var(--brand-blue, #1A1D24);
            }
          }
        }
      }
    }
  }

  .merchantInfo {
    width: calc(1200px - 50px);
    background: var(--bg-card, #FFFFFF);
    padding: 30px 25px 50px;

    .head {
      margin: 0 0 19px;
      padding: 0 17px 20px;
      border-bottom: 2px solid var(--border-soft, #E8E4DE);

      .title {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-family: PingFang SC, PingFang SC-Semibold;
        font-weight: 600;
        color: var(--text-main, #111827);
        margin: 0 0 20px;

        img {
          margin: 0 8px 0 0;
        }
      }

      .merchant {
        min-height: 151px;
        background: var(--bg-section, #F7F5F2);
        border: 1px solid var(--border-soft, #E8E4DE);
        border-radius: 4px;
        overflow: hidden;

        .name {
          border-radius: 4px 4px 0 0;
          background: var(--bg-dark, #1A1D24);
          padding: 16px 21px 19px;
          font-size: 18px;
          font-family: PingFang SC, PingFang SC-Medium;
          font-weight: 500;
          text-align: LEFT;
          color: #FFFFFF;
        }

        .info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 13px 27px 17px 21px;

          .game {
            div {
              width: 700px;
              font-size: 16px;
              font-family: PingFang SC, PingFang SC-Regular;
              font-weight: 400;
              color: var(--text-secondary, #5A5F6B);
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            div:last-of-type {
              display: flex;
              align-items: center;
              margin: 16px 0 0;

              img {
                margin: 0 8px 0 0;
              }
            }
          }

          .btn {
            width: 160px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            background: var(--primary, #FF5A1F);
            border-radius: 3px;
            cursor: pointer;
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 500;
            box-shadow: 0 8px 16px rgba(255, 90, 31, 0.22);
            transition: background 0.2s ease, transform 0.2s ease;

            &:hover {
              background: var(--primary-hover, #E84A12);
              transform: translateY(-1px);
            }
          }
        }
      }
    }

    #merchantInfo {
      margin: 0 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: var(--text-main, #111827);
    }
  }
}
</style>
